"use client";

import { useEffectEvent, useState } from "react";

import { useIsomorphicLayoutEffect as useLayoutEffect } from "./use-isomorphic-layout-effect";

const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";

export function useIsTouchDevice(): boolean {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  const handleChange = useEffectEvent(() => {
    setIsTouchDevice(window.matchMedia(TOUCH_QUERY).matches);
  });

  useLayoutEffect(() => {
    handleChange();

    const mql = window.matchMedia(TOUCH_QUERY);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return isTouchDevice;
}
